import moment from 'moment';
import {
    AnswerTypeVariable,
    AnswerTypeVariableNamesList,
    NumericFormatVariable,
    NumericFormatVariableNamesList,
} from '../models/DataRequestHub/ProjectVariable';

export interface DataTableCellFormatSource {
    answerType: string;
    formType: string;
}

const numberAnswerTypeName = AnswerTypeVariableNamesList.find(
    (answerType) => answerType.id === AnswerTypeVariable.Number
).name;
const dateAnswerTypeName = AnswerTypeVariableNamesList.find(
    (answerType) => answerType.id === AnswerTypeVariable.Date
).name;
const accountingFormatName = NumericFormatVariableNamesList.find(
    (format) => format.id === NumericFormatVariable.Accounting
).name;
const percentFormatName = NumericFormatVariableNamesList.find(
    (format) => format.id === NumericFormatVariable.Percent
).name;

const formatAccountingValue = (rawValue: string): string => {
    const numericValue = Number(rawValue.replace(/[$,]/g, ''));
    if (Number.isNaN(numericValue)) {
        return rawValue;
    }
    const absoluteFormattedValue = Math.abs(numericValue).toLocaleString(
        'en-US',
        {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }
    );
    return numericValue < 0
        ? `-$${absoluteFormattedValue}`
        : `$${absoluteFormattedValue}`;
};

const formatPercentValue = (rawValue: string): string => {
    return rawValue.endsWith('%') ? rawValue : `${rawValue}%`;
};

export const storedDateFormats = ['ddd MMM DD YYYY', moment.ISO_8601];

const formatDateValue = (rawValue: string): string => {
    const parsedDate = moment(rawValue, storedDateFormats);
    return parsedDate.isValid() ? parsedDate.format('L') : rawValue;
};

export const formatDataTableCellDisplayValue = (
    column: DataTableCellFormatSource,
    rawValue: string
): string => {
    if (!rawValue) {
        return '';
    }

    if (column.answerType === dateAnswerTypeName) {
        return formatDateValue(rawValue);
    }

    if (column.answerType !== numberAnswerTypeName) {
        return rawValue;
    }

    if (column.formType === accountingFormatName) {
        return formatAccountingValue(rawValue);
    }

    if (column.formType === percentFormatName) {
        return formatPercentValue(rawValue);
    }

    return rawValue;
};
